export const reviewCreditCopy = "One Review Credit pays for one successfully completed review. Pilot reviews are not charged until billing is turned on.";
